import { Options, Vue } from 'vue-class-component';
import { isThemed } from '@/views/calculators/services/themeService';
import { isApp } from '@/views/calculators/services/environmentService';

@Options({
	name: 'CookieFooter',
	components: {},
})
export default class CookieFooter extends Vue {
	public get isThemed() {
		return isThemed();
	}

	public isLoggedInAsApp() {
		return isApp();
	}
}
